import { describeTime } from '@carrent/domain'

import { Icon } from './Icon'

/**
 * Время события в списке или карточке.
 *
 * Для офлайн-действий показывает клиентское время с пометкой:
 * молча выдавать серверное за момент действия нельзя — оно
 * отличается на часы и вводит в заблуждение при разборе.
 */
export function EventTime({ entry, className = '' }) {
  const info = describeTime(entry)
  if (!info) return null

  if (!info.isOffline) {
    return <time className={`event-time ${className}`}>{info.label}</time>
  }

  return (
    <span className={`event-time event-time--offline ${className}`} title={info.title}>
      <Icon name="warning" size={12} className="event-time__icon" />
      <time>{info.label}</time>
      <span className="event-time__badge">офлайн · +{info.delay}</span>
    </span>
  )
}
